import { useEffect } from "react";
import { api } from "@/utils/axiosInstance";

const LandTypeSelector = ({
  landDetails,
  selectedLandType,
  setSelectedLandType,
  setLandTypes,
  landTypes,
  isBtnDisabled,
}) => {
  useEffect(() => {
    getLandType();
  }, [landDetails.land_id]);

  const getLandType = () => {
    api.post("/land_types/", { land_id: landDetails.land_id }).then((res) => {
      setLandTypes(res.data.land_types);
    });
  };

  return (
    <div className="my-3 form-select-wrapper">
      <select
        className="form-select mt-2"
        value={selectedLandType}
        onChange={(e) => {
          setSelectedLandType(e.target.value);
        }}
        disabled={isBtnDisabled}
      >
        <option value={""}>Select a NFT type</option>
        {landTypes.length ? (
          landTypes.map((type, index) => (
            <option value={type} key={index}>
              {type}
            </option>
          ))
        ) : (
          <option value="">Loading...</option>
        )}
      </select>
    </div>
  );
};

export default LandTypeSelector;